module.exports = __webpack_public_path__ + "img/nuki-app-invite-en.bbfb3a8b.png";